<template>
  <div class="hall">
    <DragItDude
      class="hall-wrapper"
      v-if="places"
      :parent-width="4 * hallHeight * (2 * scaleValue)"
      :parent-height="4 * hallWidth * (2 * scaleValue)"
      :style="{
        left: '50%',
        top: '50%',
        transform: 'translate(-51%, -51%)',
      }"
    >
      <PinchZoom
        overflow="visible"
        disablePan="true"
        draggableImage="false"
        v-bind:limit-zoom="2"
        :style="{
          top: `calc(-50% + ${hallHeight / (2 / scaleValue) + topPadding}px)`,
          left: `calc(-50% + ${hallWidth / (2 / scaleValue)}px)`,
        }"
      >
        <div
          class="hall-screen"
          :style="{ width: hallWidth * scaleValue + 'px', height: 'auto' }"
        >
          <svg viewBox="0 0 525 55">
            <path
              _ngcontent-c8=""
              fill="#23262a"
              d="M 5 50 q 262.5 -40 515 0"
              stroke-linecap="round"
              stroke="#59636b"
              stroke-width="5"
            ></path>
          </svg>
        </div>
        <div
          class="hall-places"
          :style="{
            width: hallWidth * scaleValue + 'px',
            height: hallHeight * scaleValue + 'px',
          }"
        >
          <div
            class="place-row"
            v-for="row in rows"
            :key="row.Row + '-1'"
            :style="{
              left: 0,
              top: Math.round(row.Y) * scaleValue + 'px',
              fontSize: 16 * scaleValue + 'px',
              height: 20 * scaleValue + 'px',
            }"
          >
            {{ row.Row }}
          </div>
          <Place
            v-for="(place, placeIndex) in placesLocal.length > 0
              ? placesLocal
              : places"
            :key="placeIndex"
            :place="place"
            :scaleValue="scaleValue"
            v-if="session.Prices"
          ></Place>
          <div
            class="place-row"
            v-for="row in rows"
            :key="row.Row + '-2'"
            :style="{
              left: '100%',
              top: Math.round(row.Y) * scaleValue + 'px',
              fontSize: 16 * scaleValue + 'px',
              height: 20 * scaleValue + 'px',
            }"
          >
            {{ row.Row }}
          </div>
        </div>
      </PinchZoom>
    </DragItDude>

    <WarningModal
      v-if="true"
      v-bind:icon="warningImage"
      v-bind:title="warningTitle"
      v-bind:text="warningText"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { maxBy } from 'lodash';
import Place from './Place/Place';
import { types } from '../../../types';
import PinchZoom from 'vue-pinch-zoom';
import drag from '@branu-jp/v-drag';
import DragItDude from 'vue-drag-it-dude';
import WarningModal from '../../../components/modals/WarningModal';

export default {
  name: 'Hall',

  directives: {
    drag,
  },

  components: {
    Place,
    PinchZoom,
    DragItDude,
    WarningModal,
  },

  data() {
    return {
      switchControlSelectTypeSVG: require('../../../assets/switch-control-select-type.svg'),
      isOpenControlTypeTickets: true,
      window: {
        width: 0,
      },
      scaleValue: 0.5,
      scaleStepValue: 0.15,
      topPadding: 20,
      warningImage: '',
      warningTitle: '',
      warningText: '',
      counterNotification: 0,
      placesLocal: [],
    };
  },

  computed: {
    ...mapState(['places', 'cart', 'session', 'setting', 'user', 'data']),
    ...mapGetters(['notifications']),
    rows() {
      let map = new Map();
      this.places.map((temp) => map.set(temp.Row, temp.Y));
      return Array.from(map, ([Row, Y]) => ({ Row, Y }));
    },
    typePlacesSelectedTickets() {
      return this.cart.tickets
        .filter(
          (ticket, index, array) =>
            !array.slice(0, index).find((i) => i.name == ticket.name),
        )
        .map(({ name, variants }) => ({
          name,
          variants,
          count: this.cart.tickets.filter((i) => i.name === name).length,
        }));
    },
    hallWidth() {
      if (this.places.length) {
        let width = maxBy(
          this.placesLocal.length > 0 ? this.placesLocal : this.places,
          'X',
        )['X'];
        width += 70;
        // remove last char from value. Like 758 become 750
        return width.toString().slice(0, -1) + '0';
      }
    },
    hallHeight() {
      if (this.places.length) {
        let height = maxBy(
          this.placesLocal.length > 0 ? this.placesLocal : this.places,
          'Y',
        )['Y'];
        height += 70;
        // remove last char from value. Like 758 become 750
        return height.toString().slice(0, -1) + '0';
      }
    },
  },

  created() {
    window.addEventListener('resize', this.hallResize);
    this.hallResize();

    this.$store.commit(types.RESET_SESSION_END_AT);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);

    this.$store.commit(types.CLEAR_REMOVED_PLACES_LIST);
  },

  mounted() {
    this.changeIndents(this.places);
  },

  watch: {
    places(places) {
      let pl = places;
      if (this.changeIndents(places).length > 0) pl = this.placesLocal;
      this.hallResize(pl);
    },
  },

  methods: {
    changeIndents(places) {
      if (places.filter((place) => place.X === 0).length > 0) {
        this.placesLocal = places.map((place) => ({
          ...place,
          X: place.X + 74,
        }));
      }
      return this.placesLocal;
    },
    decreaseTicketTypeHandler(typeTicketName, typeDiscountTicket) {
      const changeTicket = this.cart.tickets.find(
        (ticket) =>
          ticket.name === typeTicketName &&
          ticket.typeId === typeDiscountTicket,
      );

      this.cart.tickets = this.cart.tickets.map((ticket) => {
        if (ticket.id === changeTicket.id) {
          this.cart.sum -= changeTicket.price;
          this.cart.ticketSum -= changeTicket.price;
          return { ...ticket, price: null, typeId: null };
        }

        return ticket;
      });
    },
    increaseTicketTypeHandler(typeTicketName, typeDiscountTicket) {
      const changeTicket = this.cart.tickets.find(
        (ticket) => !ticket.price && !ticket.typeId,
      );

      this.cart.tickets = this.cart.tickets.map((ticket) => {
        if (ticket.id === changeTicket.id) {
          const selectedVariants = ticket.variants.find(
            ({ typeId }) => typeId === typeDiscountTicket,
          );
          this.cart.sum += selectedVariants.Sum;
          this.cart.ticketSum += selectedVariants.Sum;
          return {
            ...ticket,
            price: selectedVariants.Sum,
            typeId: typeDiscountTicket,
          };
        }

        return ticket;
      });
    },
    hallResize(places) {
      places = this.placesLocal.length > 0 ? this.placesLocal : this.places;
      let averageCountPlacesInRows =
        places && this.rows ? places.length / this.rows.length : 0;

      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      this.scaleValue = 1;

      if (
        +this.hallWidth + 70 > this.window.width &&
        this.window.width - 200 < this.window.height
      ) {
        this.scaleValue = this.window.width / (+this.hallWidth + 70);

        if (this.window.width <= 320) {
          this.topPadding = 0;
        } else if (this.window.width <= 480) {
          this.topPadding = -10;
        }
      }
      if (
        +this.hallHeight + 210 > this.window.height &&
        this.window.width >= this.window.height
      ) {
        this.scaleValue = this.window.height / (+this.hallHeight + 250);

        if (this.window.height <= 789) {
          this.scaleValue = 0.65;
        }

        if (this.window.height <= 580) {
          this.scaleValue = 0.4;
          this.topPadding = 0;
        }
      }

      if (averageCountPlacesInRows > 30) {
        this.scaleValue *= 0.775;
      }

      /* if (this.rows.length > 24) {
        this.scaleValue *= 0.65;
      } */

      if (places && places.length > 1000) {
        this.topPadding = 50;
        this.scaleValue *= 0.52;
      }
    },
  },
  updated() {
    const notificationData = this.notifications(
      this.$route.name,
      this.session.Format.Name,
    );

    const { Image, Text, Title } = notificationData || {};

    if (
      notificationData &&
      ((Image && this.warningImage !== Image) ||
        (Text && this.warningTitle !== Title) ||
        (Title && this.warningText !== Text)) &&
      this.places &&
      this.counterNotification < 1
    ) {
      const host = process.env.VUE_APP_API_HOST_NEW_WIDGET;

      this.warningImage = Image
        ? `${typeof host === 'string' ? host.replace('api.', '') : ''}/${Image}`
        : null;
      this.warningTitle = Title;
      this.warningText = Text;
      this.$modal.show('warning-modal');
      this.counterNotification++;
    }
  },
};
</script>

<style src="./Hall.scss" lang="scss"></style>
